import { rem } from "polished";
import styled, { css } from "styled-components";

import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

const BackgroundWrapper = styled.div<{
  backgroundImage?: string;
  backgroundTint?: string;
  backgroundPosition?: string;
  imageFit?: ImageFit;
}>`
  position: relative;
  ${(props) =>
    props.backgroundImage &&
    css`
      background-image: url(${props.backgroundImage});
      background-size: ${props.imageFit || "cover"};
      background-repeat: no-repeat;
    `}

  ${(props) =>
    props.backgroundTint &&
    css`
      &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: ${props.backgroundTint};
      }
    `}

  ${(props) =>
    props.backgroundPosition &&
    css`
      background-position: ${props.backgroundPosition};
    `}
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  margin: auto;
  display: grid;
  gap: ${rem(16)};
  position: relative;

  .text-primitive {
    text-align: center;
    color: #fff;
  }
`;

const LogoWrapper = styled.div<{ isLogoResized: boolean }>`
  position: absolute;
  top: ${rem(116)};
  left: 50%;
  transform: translateX(-50%);
  max-height: ${rem(42)};
  max-width: ${rem(233)};

  ${(props) =>
    props.isLogoResized &&
    `
      height: ${rem(120)};
      max-height: ${rem(120)};
      max-width: 100%;
  `}
`;

const Logo = withViewportStyle("img")`
  object-fit: contain;
  max-width: 100%;
  max-height: ${rem(120)};

  ${(props) => props.$viewport.tablet`
    max-height: ${rem(100)};
  `}

  ${(props) => props.$viewport.mobile`
    max-height: ${rem(80)};
  `}
`;

const TimeAndDateItem = styled.div`
  padding: ${rem(12)};
`;

const TimeAndDateWrapper = styled.div`
  max-width: ${rem(392)};
  width: 100%;
  margin: ${rem(32)} auto ${rem(40)} auto;
  display: grid;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  grid-auto-flow: column;

  ${TimeAndDateItem}:not(:last-of-type) {
    border-right: 1px solid #fff;
  }
`;

const CTAWrapper = styled.div`
  margin: auto;
`;

const RichTextContainer = styled.div`
  display: grid;
  grid-gap: ${rem(16)};
  max-width: ${rem(800)};

  .default .ck-content h1,
  .default .ck-content h2,
  .default .ck-content h3,
  .default .ck-content h4,
  .default .ck-content h5,
  .default .ck-content p,
  .default .ck-content li {
    margin: 0;
    color: #fff;
  }
`;

export {
  BackgroundWrapper,
  ContentWrapper,
  CTAWrapper,
  LogoWrapper,
  Logo,
  RichTextContainer,
  TimeAndDateWrapper,
  TimeAndDateItem,
};
